


import Vue from 'vue';
import freezeMixin from './freezeMixin';

export default Vue.extend({
  mixins: [freezeMixin],
});
